import { Box } from '@chakra-ui/react';
import { InsuranceInfoWrapperProps } from './InsuranceInfo';
import { Container } from '../../theme/components/Container'

export const InsuranceInfoWrapper = ({ isSticky, ...rest }: InsuranceInfoWrapperProps) => {
    return (
        <Box
            as="aside"
            sx={{
                w: '100%',
                maxW: Container.baseStyle.maxW,
                mx: 'auto',
                position: {
                    base: 'static',
                    lg: isSticky && 'sticky',
                },
                top: 0,
                zIndex: {
                    base: 'base',
                    lg: 'sticky',
                },
            }}
            {...rest} />
    );
};
